'use strict'

module.exports = function assertFunction (value) {
  if (typeof value !== 'function') {
    throw new TypeError('Expected function, got: ' + value)
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/assert-function/index.js
// module id = 119
// module chunks = 0